import {
  registerProvisionalCompanyUserHandler,
  registerProvisionalCompanyWithBizsolHandler,
  registerProvisionalCompanyWithConnectBoardHandler,
  sendForgotPasswordMailHandler,
  verifyForgotPasswordTokenHandler,
  UpdatePasswordMutationHandler,
  verifyProvisionalRegistrationTokenHandler,
  verifyProvisionalRegistrationTokenWithBizsolMutationHandler,
  verifyProvisionalRegistrationTokenWithConnectBoardMutationHandler,
  registerNewCompanyHandler,
  registerNewCompanyWithBizsolHandler,
  registerCompanyUserHandler,
  registerMemberWithBizsolHandler,
  registerVerifiedCompanyWithBizsolHandler,
  registerVerifiedCompanyWithConnectBoardHandler,
  deleteCompanyUserHandler,
  editCompanyUserHandler,
  requestChangeEmailAddressHandler,
  verifyEmailAddressHandler,
  applyForChangeToAdminHandler,
  signInWithBizsolMutationHandler,
  changeBizsolStateToWaitingHandler,
  connectToBizsolHandler,
  switchBizsolIDHandler,
  acceptCompanyWithdrawalHandler,
  changeToMemberHandler,
  disconnectFromBizsolHandler,
  provisionalContractMutationHandler,
  provisionalOptionContractMutationHandler,
  changePlanContractMutationHandler,
  cancelOptionMutationHandler,
  cancelContractMutationHandler,
  cancelReversalMutationHandler,
  deleteAdminMutationHandler,
  addAdminMutationHandler,
  editCompanyInfoHandler,
  registerCompanyInfoHandler,
  signInWithConnectBoardMutationHandler,
  connectToConnectBoardHandler,
  registerNewCompanyWithConnectBoardHandler,
  verifyChangeToAdminTokenHandler,
  resignTermsOfServiceHandler,
  updateTemporaryPasswordHandler,
} from "@/repositories/mocks/graphql/mutation";
import {
  getUsersHandler,
  getUserHandler,
  meHandler,
  getMyBizsolStateHandler,
  getBizsolEmailHandler,
  getMyConnectBoardStateHandler,
  servicesHandler,
  servicesForPublicHandler,
  bankServicesHandler,
  companyHandler,
  cardRegistrationUrlHandler,
  adminUsersAtMikatanoIDHandler,
  alertsHandler,
  getBankBranchOfficesHandler,
  getCompanyInfoHandler,
  nowHandler,
  isCouponCodeAvailableHandler,
  getAddressHandler,
} from "@/repositories/mocks/graphql/query";

export const handlers = [
  registerProvisionalCompanyUserHandler,
  registerProvisionalCompanyWithBizsolHandler,
  registerProvisionalCompanyWithConnectBoardHandler,
  sendForgotPasswordMailHandler,
  verifyForgotPasswordTokenHandler,
  UpdatePasswordMutationHandler,
  getUsersHandler,
  getUserHandler,
  registerNewCompanyHandler,
  registerNewCompanyWithBizsolHandler,
  registerCompanyUserHandler,
  registerMemberWithBizsolHandler,
  registerVerifiedCompanyWithBizsolHandler,
  registerVerifiedCompanyWithConnectBoardHandler,
  verifyProvisionalRegistrationTokenHandler,
  verifyProvisionalRegistrationTokenWithBizsolMutationHandler,
  verifyProvisionalRegistrationTokenWithConnectBoardMutationHandler,
  deleteCompanyUserHandler,
  editCompanyUserHandler,
  changeToMemberHandler,
  disconnectFromBizsolHandler,
  signInWithConnectBoardMutationHandler,
  registerNewCompanyWithConnectBoardHandler,
  connectToConnectBoardHandler,
  meHandler,
  getMyBizsolStateHandler,
  getBizsolEmailHandler,
  getMyConnectBoardStateHandler,
  requestChangeEmailAddressHandler,
  verifyEmailAddressHandler,
  applyForChangeToAdminHandler,
  signInWithBizsolMutationHandler,
  changeBizsolStateToWaitingHandler,
  connectToBizsolHandler,
  switchBizsolIDHandler,
  acceptCompanyWithdrawalHandler,
  servicesHandler,
  servicesForPublicHandler,
  bankServicesHandler,
  companyHandler,
  cardRegistrationUrlHandler,
  adminUsersAtMikatanoIDHandler,
  provisionalContractMutationHandler,
  provisionalOptionContractMutationHandler,
  changePlanContractMutationHandler,
  cancelContractMutationHandler,
  cancelOptionMutationHandler,
  cancelContractMutationHandler,
  cancelReversalMutationHandler,
  deleteAdminMutationHandler,
  addAdminMutationHandler,
  alertsHandler,
  getBankBranchOfficesHandler,
  getCompanyInfoHandler,
  registerCompanyInfoHandler,
  editCompanyInfoHandler,
  nowHandler,
  isCouponCodeAvailableHandler,
  resignTermsOfServiceHandler,
  verifyChangeToAdminTokenHandler,
  updateTemporaryPasswordHandler,
  getAddressHandler,
];
